import { CurrencyPipe, LowerCasePipe, UpperCasePipe } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';
import { BadgeComponent, ButtonComponent } from '@core/ui-kit/components';
import { CheckboxCircleFillComponent } from '@core/ui-kit/components/icons/checkbox-circle-fill.component';
import { environment } from '@environments/environment';
import { TranslocoPipe } from '@jsverse/transloco';
import { Product } from '@shared/data-access/data-access-payment';

@Component({
  selector: 'app-subscription-plan-card',
  imports: [
    TranslocoPipe,
    LowerCasePipe,
    UpperCasePipe,
    CurrencyPipe,
    ButtonComponent,
    CheckboxCircleFillComponent,
    BadgeComponent,
  ],
  templateUrl: './subscription-plan-card.component.html',
  styleUrl: './subscription-plan-card.component.scss',
})
export class SubscriptionPlanCardComponent {
  product = input.required<Product>();
  cyberExposureProducts = input.required<Product[]>();

  startSubscription = output<{ product: Product; cyberExposureProductId: string | null }>();

  enterprisePlanEmail = environment.stripe.enterprisePlanEmail;

  selectedCyberExposureProductId = signal<string | null>(null);
  selectedCyberExposureProduct = signal<Product | null>(null);

  descriptionItems = computed(() => {
    const description = this.product().description;

    if (!description) {
      return [];
    }

    return description.split(this.descriptionDivider).map((item) => item.trim());
  });

  private descriptionDivider = '|';

  selectCyberExposureProduct(product: Product | null): void {
    this.selectedCyberExposureProductId.set(product ? product.id : null);
    this.selectedCyberExposureProduct.set(product);
  }

  createSubscription(): void {
    this.startSubscription.emit({
      product: this.product(),
      cyberExposureProductId: this.selectedCyberExposureProduct()?.defaultPrice.id || null,
    });
  }
}
